import { render, staticRenderFns } from "./ReviewRegistView.vue?vue&type=template&id=1a597893&"
import script from "./ReviewRegistView.vue?vue&type=script&lang=js&"
export * from "./ReviewRegistView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports